export default __webpack_public_path__ + "static/media/francois-hoang-xxZCfAnMUrM-unsplash-original.849a3bcd.jpg";